import { initGtm } from '@link/share/vendors/gtm';

initGtm({
  gtmId: 'GTM-KXQCZ555',
  environment: import.meta.env.VITE_APP_SHIBUYA_SKY_ENV || ''
});
